import React from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'primereact/button';
import Pagamento from '../pagamento';
import './styles.css';

const CobAd = (props) => {
    return (
        <div>
            <Popup
                modal
                trigger={
                    <button
                        type="submit"
                        icon="pi pi-plus"
                        iconPos="left"
                        className="btn-primary"
                    >
                        Cobrar Adesão
                    </button>
                }
            >
                {(close) => (
                    <>
                        <Pagamento inscricao={props.inscricao} adesao={120} />
                        <Button type="submit" label="Fechar" onClick={close} />
                    </>
                )}
            </Popup>
        </div>
    );
};

export default CobAd;
